export class ProfileModel {
  constructor(public username: string,
              public imageUrl: string) {
  }
}
